import { FC } from 'react'
import { ContentLoaderProps } from './ContentLoader.types'
import { Container } from './ContentLoader.style'
import { Loader } from '../'

const ContentLoader: FC<ContentLoaderProps> = ({
  isLoading,
  loaderSize,
  children,
  ...props
}) => {
  return (
    <Container {...props}>
      {isLoading ? <Loader size={loaderSize} /> : children}
    </Container>
  )
}

export default ContentLoader
